module.exports = __webpack_public_path__ + "media/images/brand/newsletter/cave_man_400-4c85e3603ae7d1d341ae7c99068ddb64.png";